import axios from "axios";
import config from "@Config/index";

export interface RedirectItem {
  id: number;
  from: string;
  to: string;
  type: string;
}

export interface RedirectsResponse {
  docs: RedirectItem[];
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  prevPage: number | null;
  nextPage: number | null;
}

export const fetchRedirects = async (limit = 0): Promise<RedirectsResponse> => {
  const response = await axios.get<RedirectsResponse>(
    `${config.CMS_API_URL}/api/redirects?limit=${limit}`, // replace with payload api endpoint
  );
  return response.data;
};

export const transformRedirectsToMap = (redirects: RedirectItem[]): Record<string, string> => {
  const redirectMap: Record<string, string> = {};

  redirects.forEach((redirect) => {
    redirectMap[redirect.from] = redirect.to;
  });

  return redirectMap;
};
